import { CustomerBalances } from '../../models/sale'
import { getAbpOutstandingBalance } from '../../constants/abp-balance-type'
import { getMaxPayableAmount } from '../../functions/invoicing/max-payable-amount'
import { resolveAbpInitialAmount } from './resolveAbpInitialAmount'

/**
 * Resolves and safely caps URL-prefilled account balance payment (ABP) amount using customer balance.
 *
 * This helper exists to keep the full initialization decision path in one place:
 * 1) derive outstanding debt from the combined account balance,
 * 2) subtract in-transit pay-balance / ACH so the prefill cannot re-collect it,
 * 3) apply existing URL amount parsing/validation against that max payable.
 *
 * Keeping this composition in a dedicated function allows unit tests to cover
 * the sale-initialization wiring without mounting the `useSaleInitialising` hook.
 */
export const resolveAbpInitialAmountForBalances = (
  prefilledAmountParam: string | null,
  balances: Pick<CustomerBalances, 'account'>,
  inTransitAmount = 0
): number => {
  const outstandingBalance = getAbpOutstandingBalance(balances)
  const maxPayable = getMaxPayableAmount(outstandingBalance, inTransitAmount)

  return resolveAbpInitialAmount(prefilledAmountParam, maxPayable)
}
